var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottomMini = function SvgBottomMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3813 4.99774C5.5973 4.99774 4.92233 5.55123 4.76877 6.32006L3.31411 13.6033C3.12577 14.5464 3.78329 15.449 4.73862 15.559L8.52785 15.9951C8.89451 16.0373 9.23506 15.7995 9.32164 15.4407C9.50159 14.6951 10.5622 14.6951 10.7421 15.4407C10.8287 15.7995 11.1693 16.0373 11.5359 15.9951L15.3252 15.559C16.2805 15.449 16.938 14.5464 16.7497 13.6033L15.295 6.32006C15.1415 5.55123 14.4665 4.99774 13.6825 4.99774H10.2043H9.8595H6.3813Z",
    fill: "#00A5B9"
  })));
};
export default SvgBottomMini;